import { Link } from 'react-router-dom';
import { buttonVariants } from '@/components/ui/Button';
import { ArrowRight, Globe, Lock, Sparkles, Users } from 'lucide-react';

const VALUES = [
  { icon: Globe, title: 'Japanese & English, day one', body: 'Every original ships with both JA and EN audio at release — no sub-before-dub waiting.' },
  { icon: Lock, title: 'Studio-owned originals', body: "Everything here is Nullify Entertainment's own work — produced, cast, and credited in-house." },
  { icon: Sparkles, title: 'Built for fans', body: 'Fair pricing, no dark patterns, cancel anytime, and previews free for everyone.' },
];

export function AboutPage() {
  return (
    <div>
      <section className="relative overflow-hidden bg-brand-radial">
        <div className="container-page py-16 md:py-24">
          <div className="max-w-2xl">
            <p className="eyebrow mb-3">About BingeBox</p>
            <h1 className="font-display text-display-sm font-extrabold text-ink md:text-display">
              A tiny studio with <span className="text-gradient">big stories.</span>
            </h1>
            <p className="mt-5 text-lg text-ink-muted">
              BingeBox is the streaming home of Nullify Entertainment — a solo founder and a crew of
              volunteer voice actors building original series we'd actually want to watch.
            </p>
          </div>
        </div>
      </section>

      <section className="container-page py-14">
        <div className="grid gap-4 sm:grid-cols-3">
          {VALUES.map(({ icon: Icon, title, body }) => (
            <div key={title} className="card p-6">
              <div className="mb-4 grid h-11 w-11 place-items-center rounded-xl bg-surface-raised text-brand-soft">
                <Icon size={22} strokeWidth={1.75} />
              </div>
              <h2 className="font-display text-base font-bold text-ink">{title}</h2>
              <p className="mt-2 text-sm text-ink-muted">{body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="border-t border-border bg-panel">
        <div className="container-page py-14 text-center">
          <h2 className="font-display text-2xl font-bold text-ink">Want to be part of it?</h2>
          <p className="mx-auto mt-3 max-w-prose text-ink-muted">
            Pitch a show or request upload access on the Dev Forums — we read every submission.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <Link to="/dev" className={buttonVariants({ variant: 'primary', size: 'lg' })}>
              <Users size={18} /> Visit the Dev Forums
            </Link>
            <Link to="/browse" className={buttonVariants({ variant: 'secondary', size: 'lg' })}>
              Browse the catalog <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
